export default {
  Codigo: 2,
  Descripcion: '',
  Abreviatura: '',
  Activo: true,
};
